import {
  FocusClass,
  FORM_CONTROLLER_ID,
  LIGHTBOX_CONTROLLER_ID,
  HashLinkFix,
  initializer,
  JSAttr,
  PageUpdater,
  Toggle,
} from 'js-common';

import {
  CERTIFICATE_CONTROLLER_ID,
  CHARACTER_COUNTER_CONTROLLER_ID,
  INTRO_CONTROLLER_ID,
  PAYMENT_CONTROLLER_ID,
} from './constants';
import Basket from './Basket';
import Menu from './Menu';
import Messages from './Messages';
import MonthlyDonorForm from './MonthlyDonorForm';
import Donation from './Donation';

initializer
  .register([
    FocusClass,
    HashLinkFix,
    JSAttr,
    Toggle,
    Menu,
    Basket,
    PageUpdater,
    Messages,
    MonthlyDonorForm,
    Donation,
    [
      CERTIFICATE_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Certificate' */ './Certificate'),
    ],
    [
      CHARACTER_COUNTER_CONTROLLER_ID,
      () =>
        import(/* webpackChunkName: 'CharacterCounter' */ './CharacterCounter'),
    ],
    [
      INTRO_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Intro' */ './Intro'),
    ],
    [
      PAYMENT_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Payment' */ './Payment'),
    ],
    [
      FORM_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Form' */ 'js-common/Form'),
    ],
    [
      LIGHTBOX_CONTROLLER_ID,
      () => import(/* webpackChunkName: 'Lightbox' */ 'js-common/Lightbox'),
    ],
  ])
  .init();
